'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var icon$1 = require('./icon.js');
var useDidUpdate = require('../hooks/useDidUpdate.js');
var text = require('./text.js');
var popper$1 = require('./popper.js');
var dayjs = require('dayjs');
var useCombinedRef = require('../hooks/useCombinedRef.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var dayjs__default = /*#__PURE__*/_interopDefaultLegacy(dayjs);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  width: 100%;\n  cursor: pointer;\n  ", "\n  &:focus {\n    outline: 0 none;\n    box-shadow: none;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  p {\n    width: calc(100% / 7);\n    padding: 4px;\n    text-align: center;\n    height: 38px;\n    width: 38px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 3px;\n    font-size: 13px;\n    line-height: 13px;\n    transition: all 0.2s ease;\n    color: ", ";\n    &:hover {\n      color: ", ";\n      background-color: #ebe4f6;\n    }\n    &.disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n      &:hover {\n        color: inherit;\n        background-color: inherit;\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var advancedFormat = require('dayjs/plugin/advancedFormat');

dayjs__default['default'].extend(advancedFormat);
var Picker = styled__default['default'].div(_templateObject());
var Head = styled__default['default'].div(_templateObject2());
var Days = styled__default['default'].div(_templateObject3(), function (props) {
  return props.theme.colors.grey['10'];
}, function (props) {
  return props.theme.colors.primary;
});
var Input = styled__default['default'].input.attrs(function () {
  return {
    _component: 'input.normal'
  };
})(_templateObject4(), function (props) {
  return props.icon ? 'padding-right: 34px;' : '';
}, function (props) {
  return index.styleEngine(props.inputProps);
});
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var today = dayjs__default['default']();
var popper = {
  width: '282px',
  padding: '8px',
  boxShadow: '0px 0px 8px rgba(37, 40, 43, 0.12)',
  borderRadius: '4px',
  position: 'bottom'
};
var icon = {
  fontWeight: 'bold',
  cursor: 'pointer'
};

var getDefault = function getDefault(min, value, format, key) {
  return (value ? dayjs__default['default'](value, format) : min ? dayjs__default['default'](min, format) : dayjs__default['default'](today)).get(key);
};

var DatePicker = /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var onChange = _ref.onChange,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      propValue = _ref.value,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'YYYY-MM-DD' : _ref$format,
      _ref$displayFormat = _ref.displayFormat,
      displayFormat = _ref$displayFormat === void 0 ? 'Do MMM YYYY' : _ref$displayFormat,
      min = _ref.min,
      max = _ref.max,
      popperProps = _ref.popperProps,
      iconProps = _ref.iconProps,
      propOpen = _ref.open,
      disabled = _ref.disabled,
      restProps = _objectWithoutProperties(_ref, ["onChange", "onClose", "onOpen", "value", "format", "displayFormat", "min", "max", "popperProps", "iconProps", "open", "disabled"]);

  var _useState = React.useState(getDefault(min, propValue, format, 'year')),
      _useState2 = _slicedToArray(_useState, 2),
      year = _useState2[0],
      setYear = _useState2[1];

  var _useState3 = React.useState(getDefault(min, propValue, format, 'month')),
      _useState4 = _slicedToArray(_useState3, 2),
      month = _useState4[0],
      setMonth = _useState4[1];

  var _useState5 = React.useState(propValue ? dayjs__default['default'](propValue, format).format(format) : ''),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1];

  var _useState7 = React.useState(propOpen),
      _useState8 = _slicedToArray(_useState7, 2),
      open = _useState8[0],
      setOpen = _useState8[1];

  var inputRef = useCombinedRef['default'](ref);
  useDidUpdate['default'](function () {
    setOpen(propOpen);
  }, [propOpen]);
  useDidUpdate['default'](function () {
    setYear(getDefault(min, propValue, format, 'year'));
    setMonth(getDefault(min, propValue, format, 'month'));
    setValue(propValue ? dayjs__default['default'](propValue, format).format(format) : '');
  }, [propValue, min]);
  useDidUpdate['default'](function () {
    if (open) {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      onOpen && onOpen();
    } else {
      onClose && onClose();
    }
  }, [open]);
  useDidUpdate['default'](function () {
    setOpen(false);
    onChange && onChange(value);
  }, [value]);
  var days = dayjs__default['default']("".concat(months[month === 11 ? 0 : month + 1], " 01 ").concat(month === 11 ? year + 1 : year)).diff(dayjs__default['default']("".concat(months[month], " 01 ").concat(year)), 'days');

  var prevMonth = function prevMonth() {
    if (month === 0) {
      setYear(year - 1);
      setMonth(11);
    } else {
      setMonth(month - 1);
    }
  };

  var nextMonth = function nextMonth() {
    if (month === 11) {
      setYear(year + 1);
      setMonth(0);
    } else {
      setMonth(month + 1);
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(popper$1['default'], _extends({
    trigger: "custom",
    onClickAway: function onClickAway() {
      return setOpen(false);
    },
    closeOnClickAway: false
  }, popper, popperProps, {
    open: open,
    node: /*#__PURE__*/React__default['default'].createElement(Picker, null, /*#__PURE__*/React__default['default'].createElement(Head, null, /*#__PURE__*/React__default['default'].createElement(icon$1['default'], _extends({
      ml: "12px",
      mr: "auto",
      icon: "pyt-chevron-left-24",
      onClick: function onClick() {
        return prevMonth();
      }
    }, icon, iconProps)), /*#__PURE__*/React__default['default'].createElement(text['default'], {
      variant: "subtitle"
    }, months[month]), /*#__PURE__*/React__default['default'].createElement(text['default'], {
      ml: "4px",
      variant: "subtitle"
    }, year), /*#__PURE__*/React__default['default'].createElement(icon$1['default'], _extends({
      ml: "auto",
      mr: "12px",
      icon: "pyt-chevron-right-24",
      onClick: function onClick() {
        return nextMonth();
      }
    }, icon, iconProps))), /*#__PURE__*/React__default['default'].createElement(Days, null, Array.from(Array(days), function (_, i) {
      return i + 1;
    }).map(function (num, inx) {
      var date = dayjs__default['default']("".concat(num, " ").concat(months[month], " ").concat(year), 'D MMM YYYY').format(format);
      var active = date === value;
      var disabled = (min ? dayjs__default['default'](date, format).isBefore(min) : false) || (max ? dayjs__default['default'](date, format).isAfter(max) : false);
      return /*#__PURE__*/React__default['default'].createElement(text['default'], {
        onClick: function onClick() {
          return !disabled && setValue(dayjs__default['default']("".concat(months[month], " ").concat(num, " ").concat(year)).format(format));
        },
        color: active ? 'primary' : 'grey.10',
        backgroundColor: active ? '#ebe4f6' : '',
        fontWeight: active ? 'bold' : 'normal',
        className: disabled ? 'disabled' : '',
        key: inx
      }, num);
    })))
  }), /*#__PURE__*/React__default['default'].createElement(Input, _extends({
    ref: inputRef,
    "data-shift-label": ![undefined, null, ''].includes(value) ? true : false,
    autoComplete: "none",
    value: value ? dayjs__default['default'](value).format(displayFormat) : ''
  }, restProps, {
    onClick: function onClick() {
      return !disabled && setOpen(true);
    }
  })));
});
DatePicker.propTypes = {
  placeHolder: PropTypes__default['default'].string
};

exports.default = DatePicker;
